import { apiClient } from "@/services/apiClient";

/**
 * Move a live request off the professional holding it.
 *
 * Until this existed, a professional who went quiet, took on too much, or
 * turned out to be the wrong discipline had to be worked around by closing the
 * request and asking the consumer to file it again.
 *
 * Kept separate from platformRequestPauseService even though both post to
 * `/platform/requests/:channel/:id/*`: pausing halts work and keeps the
 * assignment, reassigning changes who is responsible. Sharing a module would
 * suggest they are variants of one action.
 */
export type ReassignChannel = "notary" | "accountant";

export type ReassignMode =
  /** Return it to the pool and let any eligible professional claim it. */
  | "rebroadcast"
  /** Hand it to a named professional. */
  | "direct";

export type ReassignRequestBody = {
  mode: ReassignMode;
  /** Required for `direct`; ignored for `rebroadcast`. */
  toProfessionalUserId?: string;
  /**
   * REQUIRED, min 3 chars server-side. An action that changes who is
   * responsible for someone's legal work should not be anonymous.
   */
  reason: string;
};

export function reassignRequest(
  channel: ReassignChannel,
  requestId: string,
  body: ReassignRequestBody,
): Promise<{ ok: true; outgoingProfessionalUserId: string | null }> {
  return apiClient
    .post<{ ok: true; outgoingProfessionalUserId: string | null }>(
      `/platform/requests/${channel}/${requestId}/reassign`,
      body,
    )
    .then((res) => res.data);
}
